import type { DistanceUnit } from '../models/common';

const KM_TO_MI_FACTOR = 0.621371;

const getDistanceInUnit = (distanceInKm: number, distanceUnit: DistanceUnit): number =>
  ({
    km: distanceInKm,
    mi: distanceInKm * KM_TO_MI_FACTOR,
  })[distanceUnit];

export const formatDistance = (distanceInKm: number, distanceUnit: DistanceUnit) =>
  `${(Math.round(getDistanceInUnit(distanceInKm, distanceUnit) * 10) / 10).toFixed(
    1,
  )} ${distanceUnit}`;

const deg2rad = (deg: number) => {
  return deg * (Math.PI / 180);
};

// Made use of the Harvensine formula https://www.igismap.com/haversine-formula-calculate-geographic-distance-earth/
export const getDistanceFromLatLonPoints = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
) => {
  const EARTH_RADIUS = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const distanceInKm = EARTH_RADIUS * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(distanceInKm * 10) / 10;
};

export const getRadiusInKm = (radius: number, distanceUnit: DistanceUnit): number =>
  ({
    km: radius,
    mi: Math.round(radius / KM_TO_MI_FACTOR),
  })[distanceUnit];
